import {defineEnv, VariablesExport} from '@cosctl/environment';

export const variables = {
  RPC_BASE_URL: defineEnv({
    key: 'PUBLIC_RPC_BASE_URL',
    default: 'http://localhost:8080',
    description: 'RPC base URL',
  }),
} satisfies VariablesExport;
